import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import styles from '../branches/BranchDrawer.module.css';
import { apiGetReleaseNotes } from '../../api/releases';
import { isNotFound } from '../branches/branchDrawer/ChangelogPanel';

/* Renders the stored release-notes document for a release version.
   Absent (404) until the release_notes step has run — renders nothing then. */
export default function ReleaseNotesSection({ version }) {
  const [notes, setNotes] = useState(null);
  const [missing, setMissing] = useState(false);
  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setNotes(null);
    setMissing(false);
    setLoadError(false);
    apiGetReleaseNotes(version)
      .then((data) => { if (!cancelled) setNotes(data); })
      .catch((err) => { if (!cancelled) (isNotFound(err) ? setMissing(true) : setLoadError(true)); });
    return () => { cancelled = true; };
  }, [version]);

  if (loadError) {
    return (
      <div className={styles.sectionGroup} data-testid="release-notes-section">
        <div className={styles.overline}>Release notes</div>
        <div className={styles.empty}>Couldn't load release notes — check the releases API and retry.</div>
      </div>
    );
  }
  if (missing || notes === null) return null;

  const entries = (notes.data && notes.data.entries) || [];

  return (
    <div className={styles.sectionGroup} data-testid="release-notes-section">
      <div className={styles.overline}>Release notes</div>
      <div className={styles.changelogStats}>
        {`${entries.length} changes · window n${notes.from_number} → n${notes.to_number}`}
      </div>
      <div className={styles.changelogBody}>
        <ReactMarkdown
          components={{
            a: ({ node, children, ...props }) => (
              <a {...props} target="_blank" rel="noreferrer">{children}</a>
            ),
          }}
        >
          {notes.markdown}
        </ReactMarkdown>
      </div>
    </div>
  );
}
